module.exports = __webpack_public_path__ + "img/graphic_designer.f11e302a.png";